module finadai.directives {
  export var NAME = 'finadai.directives';
  export function run(){
    var directives = angular.module(NAME, []);
    directives.directive('compareTo', compareToDirective);
    directives.directive('permissionRequired', permissionRequiredDirective);
    directives.directive('notHasPermission', notHasPermissionDirective);
  }
}
finadai.directives.run();